import type { User } from '../../types/User';

/**
 * Attribute-only eligibility for the Trial Report Card: an in-trial, self-paying
 * B2C user on the Bibliothek (mU Pro) or kombi (mU 360) plan. School/B2B and
 * library-sponsored users are excluded — matching the app's B2C cohort
 * (`isBusinessUser = isSchoolUser || isLibraryUser || isKeycloakSSO`), so a
 * library-sponsored Bibliothek user doesn't get report-card hints recorded.
 *
 * The experiment-flag gate is layered on top in Phase 2 (UI only); recording is
 * driven by this attribute check alone. Returns `false` for an unloaded user.
 */
export function isTrialReportCardAttributeEligible(user: User | undefined): boolean {
	if (!user) {
		return false;
	}

	return (
		Boolean(user.isInTrial) &&
		!user.isSchoolUser &&
		!user.isLibraryUser &&
		!user.isKeycloakSSO &&
		(user.isBibliothekUser || user.isKombiUser)
	);
}
